<template>
<div class="usp-box mdc-typography mdc-typography mdc-typography--body2">
  <hr class="usp-box__separator" />
  <div class="usp-box__content">
    <p class="usp-box__content__argument" v-for="item in usp">
      <i class="material-icons">check</i> <span>{{item}}</span>
    </p>
  </div>
</div>
</template>
<script>
export default {
  computed: {
    /**
     * Get a Array of the translated USPs
     * @returns {VueI18n.TranslateResult[]}
     */
    usp () {
      return [
        this.$i18n.t('USP.USP1'),
        this.$i18n.t('USP.USP2'),
        this.$i18n.t('USP.USP3')
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../../scss/colors";
  @import "../../../scss/variables";

  .usp-box {
    &__separator {
      margin: 0 4px;
      border: none;
      border-top: 1px solid $border;
    }

    &__content {
      padding: 16px;

      &__argument {
        display: flex;
        align-items: center;

        &:first-of-type {
          margin-top: 0;
        }
      }
    }
  }

  .material-icons {
    color: $feedback;
    padding-right: 8px;
  }
</style>

